import script from "./EmergencyWindow.vue?vue&type=script&setup=true&lang=js"
export * from "./EmergencyWindow.vue?vue&type=script&setup=true&lang=js"

import "./EmergencyWindow.vue?vue&type=style&index=0&id=598b614c&scoped=true&lang=css"

import exportComponent from "F:\\Grupo Low Cost\\Aplicación Mallorca\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-598b614c"]])

export default __exports__